import { BaseControl } from "./BaseControl";
import { Controller } from "./Controller";
import { app } from "../Frame/App";

export class LanguageStringControl extends BaseControl {

    constructor(private controlId: string, controller: Controller, field: string, private multiLine: boolean, private validationMessage: string = null) {
        super(controller, field);

        let div = document.getElementById(controlId);
        if (multiLine) {
            let textareas = div.getElementsByTagName("textarea");
            if (textareas && textareas.length > 0) {
                for (var i = 0; i < textareas.length; i++) {
                    this.controller.addControlByElement(textareas[i], field + "." + textareas[i].getAttribute("data-field"));
                }
            }
        }
        else {
            let inputs = div.getElementsByTagName("input");
            if (inputs && inputs.length > 0) {
                for (var i = 0; i < inputs.length; i++) {
                    this.controller.addControlByElement(inputs[i], field + "." + inputs[i].getAttribute("data-field"));
                }
            }
        }
    }

    updateControlFromModel() {
        // nothing to do
    }

    updateModelFromControl() {
        // nothing to do
    }

    dispose() {
        // nothing to do
    }

    validate() {
        if (this.validationMessage) {
            if (this.multiLine) {
                throw "LanguageStringControl.validate() multiline is not supported";
            }
            else {
                // get input of default language
                let input = <HTMLInputElement>document.getElementById(this.controlId + "_Value" + app.defaultLanguageUpperCase);
                if (!input.value || input.value.length == 0) {
                    throw this.validationMessage;
                }
            }
        }
    }

    focus() {
        document.getElementById(this.controlId + "_Value" + app.defaultLanguageUpperCase).focus();
    }
}
